import { v4 as uuidv4 } from "uuid";

export function formatMoney(nominal) {
  if (nominal == null || isNaN(nominal)) return "";
  else if (nominal < 0) return `-${formatMoney(Math.abs(nominal))}`;

  const nominalStr = nominal.toString().split(".");
  const decimalValue = nominalStr[1] ? `,${nominalStr[1]}` : "";

  return `Rp${nominalStr[0].replace(
    /(\d)(?=(\d\d\d)+(?!\d))/g,
    "$1."
  )}${decimalValue}`;
}

export function getCurrentYear() {
  return new Date().getFullYear();
}

export function getMessageID() {
  return uuidv4().replaceAll("-", "");
}

// Validates a `DD-MM-YYYY` string against both the exact digit shape (2-2-4)
// and a real calendar date, returning [day, month, year] or null. OCR-sourced
// DOBs can drop leading zeros (e.g. `4-06-2000`) or be otherwise malformed, so
// anything that isn't strictly valid is rejected rather than silently repaired.
function parseBackendDob(dob) {
  if (!dob || !/^\d{2}-\d{2}-\d{4}$/.test(dob)) return null;
  const [day, month, year] = dob.split("-");
  const dayNum = Number(day);
  const monthNum = Number(month);
  const yearNum = Number(year);
  const date = new Date(yearNum, monthNum - 1, dayNum);
  if (
    date.getFullYear() !== yearNum ||
    date.getMonth() !== monthNum - 1 ||
    date.getDate() !== dayNum
  ) {
    return null;
  }
  return [day, month, year];
}

export function dobToInputFormat(dob) {
  const parsed = parseBackendDob(dob);
  if (!parsed) return "";
  const [day, month, year] = parsed;
  return `${year}-${month}-${day}`;
}

export function dobToBackendFormat(dob) {
  if (!dob) return "";
  const [year, month, day] = dob.split("-");
  return `${day}-${month}-${year}`;
}

export function formatDob(dob, months = []) {
  const parsed = parseBackendDob(dob);
  if (!parsed) return "";
  const [day, month, year] = parsed;
  const monthName = months[Number(month) - 1];
  return monthName ? `${day} ${monthName} ${year}` : "";
}

/* 
* This function is used to sanitize HTML content to prevent XSS attacks. This will do the following:
* 1. Remove <script> tags
* 2. Remove event handler attributes (e.g., onclick, onmouseover)
*/
export function sanitizeHTML(html) {

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
  
    // Remove <script> tags
    const scriptTags = doc.querySelectorAll('script');
    scriptTags.forEach(tag => tag.remove());
  
    // Remove event handler attributes (e.g., onclick, onmouseover)
    const elements = doc.querySelectorAll('*');
    elements.forEach(element => {
      Array.from(element.attributes).forEach(attr => {
        if (attr.name.startsWith('on')) {
          element.removeAttribute(attr.name);
        }
      });
    });

    return doc.body.innerHTML;
}
